export class BaseComponent {
  /**
   * 外注権限
   * @returns 
   */
  public getOutsource(): boolean {
    return localStorage.getItem("outsource") == 'true';
  }

  /**
   * RPのURL
   * @returns 
   */
  public RPUrl(): string {
    const url = window.location.href;
    console.log(url);
    // 本番
    if (url.includes('https://akbs-systems.com')) {
      return 'https://requestpost-systems.com/'

    // 検証
    } else if (url.includes('https://develop.akbs-systems.com')) {
      return 'https://develop.requestpost-systems.com/'

    // ローカル
    } else if (url.includes('http://localhost:4200')) {
      return 'http://localhost:8100/'
    }
    return ''
  }
}
